import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NumeroCotizacionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='N. COTIZACION' htmlFor='input-numeroCotizacion' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='numeroCotizacion'>
          {({ field }) => <Form.InputText {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-numeroCotizacion' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroCotizacionFormGroup)
